import { trackingEvent } from '@notino/web-tracking';

import { getTrackingProductName } from '@utils/tracking';

import { dispatchEcommerceMessage } from '../../../messagingService';
import { ECartType, EcommerceSectionNamespace, IEcommerceCheckout } from '../../model';

/**
 * Ecommerce event for begin checkout
 * this event should be called when customer enters the checkout process from first cart page
 * @param checkout - Ecommerce object of checkout - summary of cart
 * @param cartType - either Click and Collect or regular Cart
 * @param interaction - describes which interaction has caused begin checkout event
 */
export const trackBeginCheckout = (
  checkout: IEcommerceCheckout,
  cartType: ECartType,
  interaction: EcommerceSectionNamespace.EEcommerceInteraction,
) =>
  dispatchEcommerceMessage(
    trackingEvent({
      event: EcommerceSectionNamespace.EEcommerceEvent.BEGIN_CHECKOUT,
      checkout: {
        step: EcommerceSectionNamespace.EEcommerceStepNumber.CART,
        revenue: checkout.revenue.toString(),
        tax: checkout.tax.toString(),
        total_value: checkout.totalValue.toString(),
        ...(checkout.shipping && { shipping: checkout.shipping.toString() }),
        cart_type: cartType,
        payment_type: checkout.paymentType,
        interaction: interaction,
        delivery_type: checkout.deliveryType,
        products: checkout.products.map((product) => ({
          product_code: product.productCode,
          product_name: getTrackingProductName(product),
          brand_name: product.brandName,
          primary_category: product.primaryCategories.category,
          primary_subcategory: product.primaryCategories.subCategory,
          primary_type: product.primaryCategories.type,
          kind: product.primaryCategories.kind,
          full_price: product.fullPrice,
          availability: product.stockAvailability,
          price: product.price,
          quantity: product.quantity,
          group: product.group,
        })),
      },
      _clear: true,
    }),
  );
